export default "__VITE_ASSET__C6_W2HJn__"